"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXITING = exports.EXITED = exports.ENTERING = exports.ENTERED = void 0;
const EXITED = exports.EXITED = 'exited';
const ENTERING = exports.ENTERING = 'entering';
const ENTERED = exports.ENTERED = 'entered';
const EXITING = exports.EXITING = 'exiting';